<template>
  <div class="wlmq_mediaBroad_container">
    <div class="head">
      <div class="head_title">
        <img src="../../../assets/Uram/Uramvideo/articleLogo_02.png" />
         竞争对比播报
      </div>
      <div class="head_logo">
        <img src="../../../assets/Uram/Uramvideo/articleLogo.png" />
      </div>
    </div>
   <div class="main_box">
    <div class="main_box_time">
       <div class="main_title">
         {{title1}}
       </div>
    
    <div class="main_time" v-if="this.list1.length<=5">
        <div class="main_li"   v-for="(item,index) in list1" :key="index">
        <div class="li_img">
          <div class="li_top"></div>
          <img style="position:relative;left:2px" src="../../../assets/Uram/Uramvideo/imyuan.png" alt="">
          <div class="li_bottom"></div>
        </div>
        <div class="li_div" id="li_div1">
          <div class="li_option"  @click="showDialog(item)">
            <img class="option_img" v-if="item.cover!=null"  :src="item.cover" alt="">
          <div class="option_title"   >
            {{item.title}}
          </div>
          </div>
   
       <div class="option_bottom">
       <div class="option_soure">
         {{item.SOURCE_NAME}}
       </div>
       <div class="option_date">
         {{item.NEWS_TIME}}
       </div>
       </div>
        </div>
        </div>  
    </div>


       <div class="main_time" v-else>
       <vue-seamless-scroll
         :data="list1"
         class="seamless-warp"
         :class-option="defaultOption"
       >
    <div class="main_li"   v-for="(item,index) in list1" :key="index">
        <div class="li_img">
          <div class="li_top"></div>
          <img style="position:relative;left:2px" src="../../../assets/Uram/Uramvideo/imyuan.png" alt="">
          <div class="li_bottom"></div>
        </div>
        <div class="li_div" id="li_div1">
          <div class="li_option"  @click="showDialog(item)" >
            <img class="option_img" v-if="item.cover!=null"  :src="item.cover" alt="">
          <div class="option_title"  >
            {{item.title}}
          </div>
          </div>
   
       <div class="option_bottom">
       <div class="option_soure">
         {{item.SOURCE_NAME}}
       </div>
       <div class="option_date">
         {{item.NEWS_TIME}}
       </div>
       </div>
        </div>
        </div>
        </vue-seamless-scroll>
    </div>



    </div>
    <div class="main_box_time">
    <div class="main_title">
         {{title2}}
       </div>
   <div class="main_time" v-if="this.list2.length<=5">
        <div class="main_li"   v-for="(item,index) in list2" :key="index">
        <div class="li_img">
          <div class="li_top"></div>
          <img style="position:relative;left:2px" src="../../../assets/Uram/Uramvideo/imyuan.png" alt="">
          <div class="li_bottom"></div>
        </div>
        <div class="li_div" id="li_div1">
          <div class="li_option"  @click="showDialog(item)">
          <img class="option_img" v-if="item.cover!=null"  :src="item.cover" alt="">
          <div class="option_title"   >
            {{item.title}}
          </div>
          </div>
   
       <div class="option_bottom">
       <div class="option_soure">
         {{item.SOURCE_NAME}}
       </div>
       <div class="option_date">
         {{item.NEWS_TIME}}
       </div>
       </div>
        </div>
        </div>  
    </div>

 <div class="main_time" v-else>
       <vue-seamless-scroll
         :data="list2"
         class="seamless-warp"
         :class-option="defaultOption"
       >
    <div class="main_li"   v-for="(item,index) in list2" :key="index">
        <div class="li_img">
          <div class="li_top"></div>
          <img style="position:relative;left:2px" src="../../../assets/Uram/Uramvideo/imyuan.png" alt="">
          <div class="li_bottom"></div>
        </div>
        <div class="li_div" id="li_div1">
          <div class="li_option"  @click="showDialog(item)">
          <img class="option_img" v-if="item.cover!=null"  :src="item.cover" alt="">
          <div class="option_title"   >
            {{item.title}}
          </div>
          </div>
   
       <div class="option_bottom">
       <div class="option_soure">
         {{item.SOURCE_NAME}}
       </div>
       <div class="option_date">
         {{item.NEWS_TIME}}
       </div>
       </div>
        </div>
        </div>
        </vue-seamless-scroll>
       </div>
    </div>
    <div class="main_box_time">
     <div class="main_title">
         {{title3}}
       </div>
       <div class="main_time" v-if="this.list3.length<=5">
        <div class="main_li"   v-for="(item,index) in list3" :key="index">
        <div class="li_img">
          <div class="li_top"></div>
          <img style="position:relative;left:2px" src="../../../assets/Uram/Uramvideo/imyuan.png" alt="">
          <div class="li_bottom"></div>
        </div>
        <div class="li_div" id="li_div1">
          <div class="li_option"  @click="showDialog(item)">
          <img class="option_img" v-if="item.cover!=null"  :src="item.cover" alt="">
          <div class="option_title"   >
            {{item.title}}
          </div>
          </div>
   
       <div class="option_bottom">
       <div class="option_soure">
         {{item.SOURCE_NAME}}
       </div>
       <div class="option_date">
         {{item.NEWS_TIME}}
       </div>
       </div>
        </div>
        </div>  
    </div>
     <div class="main_time" v-else>
       <vue-seamless-scroll
         :data="list3"
         class="seamless-warp"
         :class-option="defaultOption"
       >
    <div class="main_li"   v-for="(item,index) in list3" :key="index">
        <div class="li_img">
          <div class="li_top"></div>
          <img style="position:relative;left:2px" src="../../../assets/Uram/Uramvideo/imyuan.png" alt="">
          <div class="li_bottom"></div>
        </div>
        <div class="li_div" id="li_div1">
          <div class="li_option"  @click="showDialog(item)">
      <img class="option_img" v-if="item.cover!=null"  :src="item.cover" alt="">
          <div class="option_title"   >
            {{item.title}}
          </div>
          </div>
   
       <div class="option_bottom">
       <div class="option_soure">
         {{item.SOURCE_NAME}}
       </div>
       <div class="option_date">
         {{item.NEWS_TIME}}
       </div>
       </div>
        </div>
        </div>
        </vue-seamless-scroll>
       </div>
    </div>
    <div class="main_box_time">
    <div class="main_title">
         {{title4}}
       </div>
       <div class="main_time" v-if="this.list4.length<=5">
        <div class="main_li"   v-for="(item,index) in list4" :key="index">
        <div class="li_img">
          <div class="li_top"></div>
          <img style="position:relative;left:2px" src="../../../assets/Uram/Uramvideo/imyuan.png" alt="">
          <div class="li_bottom"></div>
        </div>
        <div class="li_div" id="li_div1">
          <div class="li_option"  @click="showDialog(item)">
          <img class="option_img" v-if="item.cover!=null"  :src="item.cover" alt="">
          <div class="option_title"   >
            {{item.title}}
          </div>
          </div>
   
       <div class="option_bottom">
       <div class="option_soure">
         {{item.SOURCE_NAME}}
       </div>
       <div class="option_date">
         {{item.NEWS_TIME}}
       </div>
       </div>
        </div>
        </div>  
    </div>
    <div class="main_time" v-else>
       <vue-seamless-scroll
         :data="list4"
         class="seamless-warp"
         :class-option="defaultOption"
       >
    <div class="main_li"   v-for="(item,index) in list4" :key="index">
        <div class="li_img">
          <div class="li_top"></div>
          <img style="position:relative;left:2px" src="../../../assets/Uram/Uramvideo/imyuan.png" alt="">
          <div class="li_bottom"></div>
        </div>
        <div class="li_div" id="li_div1">
          <div class="li_option"  @click="showDialog(item)">
         <img class="option_img" v-if="item.cover!=null"  :src="item.cover" alt="">
          <div class="option_title"   >
            {{item.title}}
          </div>
          </div>
   
       <div class="option_bottom">
       <div class="option_soure">
         {{item.SOURCE_NAME}}
       </div>
       <div class="option_date">
         {{item.NEWS_TIME}}
       </div>
       </div>
        </div>
        </div>
        </vue-seamless-scroll>
       </div>
    </div>
   </div>
    <el-dialog
  :visible.sync="dialogVisible"
  width="30%"
  :before-close="handleClose">
   <div class="body_tiele">{{this.obj.title}} <img class="body_img" @click="goindr(obj.NET_URL)" src="@/assets/lian.png" alt=""> </div>
    <div class="live">{{this.obj.SOURCE_NAME}}<div>{{this.obj.NEWS_TIME}}</div></div>
    <div  class="body_cont">{{this.obj.CONTENT}}
      <div class="time_img" >
        <div class="wx_img" v-for="(item,index) in imgTime" :key="index">
          <img v-if="item.imgUrl!=''" class="img_wx" :src="item.imgUrl" alt="">
        </div>
        </div>
    </div>
  <span slot="footer" class="dialog-footer">
    
  </span>
</el-dialog>
</div>
</template>

<script>
import {Uramvideo} from '../../../api/UramWu/uram'
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
    components: {
    vueSeamlessScroll,
  },
    name:'Uramview',
    data(){
      return{
        title1:'乌鲁木齐广电集团',
        title2:'乌鲁木齐报业集团',
        title3:'新疆报业集团',
        title4:'新疆广电集团',
        obj:{},
        column1:1,
        column2:2,
        column3:3,
        column4:4,
         dialogVisible: false,
        list1:[],
        list2:[],
        list3:[],
        list4:[],
        imgTime:[]
      }
    },
      // 监听属性 类似于data概念
  computed: {
    defaultOption() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  mounted(){
   this.lond1();
   this.lond2();
   this.lond3();
    this.lond4();
  },
  methods:{
   lond1(){
     Uramvideo({
     column:this.column1
     }).then(res=>{
      this.list1=res.data.data
      // const over1=[]
      // this.list1.forEach(item => {
      //  over1.push(item.IMG_PATH)
      // });
      // console.log(this.list1,'223423')
      // console.log(over1,'1111')
     })
   },
    lond2(){
     Uramvideo({
     column:this.column2
     }).then(res=>{
      this.list2=res.data.data
     })
   },
    lond3(){
     Uramvideo({
     column:this.column3
     }).then(res=>{
      this.list3=res.data.data
     })
   },
    lond4(){
     Uramvideo({
     column:this.column4
     }).then(res=>{
      this.list4=res.data.data
     })
   },
 

    showDialog(item){
      this.dialogVisible=true
      this.obj=item
      const imgs=[];
    imgs.push(item.IMG_PATH.split(','))
     imgs[0].map(item=>{
      this.imgTime.push(
        {
          imgUrl:item
        }
      )   
    })

    },
       handleClose(done) {
        this.imgTime=[]
       this.dialogVisible=false

      },
       goindr(url) {
      window.open(url);
    },
  }
}
</script>

<style lang="scss" scoped>
.time_img{
  width: 100%;
  height: 5vh;
  display: flex;
// justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.wx_img{
padding: 10px;
.img_wx{
  width:170px;
  height: 140px;
}
}
.body_tiele{
  font-size: 30px;
font-family: PingFang;
font-weight: bold;
color: #FFFFFF;
line-height: 36px;
text-align: center;
}
.body_img{
  position: relative;
  left: 5px;
  cursor: pointer;
}
.live{
  width: 50%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 60px;
  margin: 0 auto;
  font-size: 18px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #60D6DD;
}
.body_cont{
  width: 90%;
  height: 60vh;
  overflow-y: scroll;
  margin: 0 auto;
  font-size: 22px;
font-family: Microsoft YaHei;
font-weight: 400;
line-height: 28px;
color: #FFFFFF;
}
.wlmq_mediaBroad_container {
  width: 100%;
  height: 100%;
  background-image: url("../../../assets/Uram/Uramvideo/expert_bg_img.jpg");
  background-size: 100% 100%;
  .head {
    width: 100%;
    height: 9.5vh;
    display: flex;
    color: #fff;

    .head_title {
      font-weight: bold;
      font-size: 2vw;
      line-height: 2.8;
      width: 19%;
      margin-left: 4.3%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      img {
        vertical-align: middle;
        width: 13.27%;
        height: 4.84vh;
        margin-right: 2.2%;
      }
    }

    .head_logo {
      width: 8.67%;
      height: 4.44vh;
      position: absolute;
      top: 4vh;
      right: 4%;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.main_box{
  width: 94%;
  height: 84vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 2vh auto;
.main_box_time{
    width: 24%;
    height: 100%;
    background: url("../../../assets/Uram/Uramvideo/broad_bg.png") no-repeat;
    background-size: 100% 100%;
.main_title{
  width: 100%;
  height:32px;
  line-height: 32px;
  font-size: 16px;
font-family: PingFang;
font-weight: 500;
text-align: center;
color: #FFFFFF;

}

.main_time{
  overflow: hidden;
  height: 76vh;
  margin-top: 2vh;

.main_li{
  width: 100%;
  height: 120px;
  display: flex;
  margin-top: 20px;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;
.li_img{
  width: 12%;
  height: 160px;
  display: flex;
  position: relative;
  // top: 20px;
  top: -6px;
  flex-direction:column;
  align-items: center;

.li_top{
  width: 1px;
  height:70px;
  border: 1px solid rgba(11, 246, 255, 1);
  position: relative;
  top: 5px;

}
.li_bottom{
   width: 1px;
  height: 100px;
  border: 1px solid rgba(11, 246, 255, 1);
  position: relative;
  top: -5px;
}
}
#li_div1{
  background: url("../../../assets/Uram/Uramvideo/1.png")no-repeat;
  background-size: 100% 100%;
}
#li_div2{
  background: url("../../../assets/Uram/Uramvideo/2.png")no-repeat;
  background-size: 100% 100%;
}
#li_div3{
  background: url("../../../assets/Uram/Uramvideo/3.png")no-repeat;
  background-size: 100% 100%;
}
#li_div4{
  background: url("../../../assets/Uram/Uramvideo/4.png")no-repeat;
  background-size: 100% 100%;
}
.li_div{
  width: 84%;
  height: 120px;
  position: relative;
  left: -8px;
.li_option{
  width: 100%;
  height: 83px;
 padding: 3px;
  display: flex;
  justify-content: space-around;
  position: relative;
.option_img{
  width: 74px;
  height: 74px;
}
.option_title{
  width: 100%;
  height: 50px;
  font-size: 18px;
font-family: PingFang;
font-weight: bold;
color: #FFFFFF;
line-height:26px;
word-break: break-all;
text-overflow: ellipsis;
overflow: hidden;
display: -webkit-box;
-webkit-line-clamp: 2;
-webkit-box-orient: vertical;
}
}
.option_bottom{
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 25px;
  line-height: 12px;
  border-top: 1px dashed rgba(255, 255, 255, 1);
  display: flex;
  padding: 5px;
  justify-content: space-between;
.option_soure{
    font-size: 14px;
font-family: PingFang;
font-weight: 500;
color: #FFFFFF;
}
.option_date{
  font-size: 14px;
font-family: PingFang;
font-weight: bold;
color: #FFFFFF;
}
}

}



}

}



}
}

</style>